import React from 'react';
import PropTypes from 'prop-types';

function EmptyCellRenderer(props) {
  const { text } = props;
  if (props.node && props.node.group) {
    return null;
  }
  return (
    <em className="text-muted">{text}</em>
  );
}

EmptyCellRenderer.propTypes = {
  text: PropTypes.string,
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
};
EmptyCellRenderer.defaultProps = {
  text: 'N/A',
};

export default EmptyCellRenderer;
